import styled from 'styled-components';

export const WrapperDiv = styled.div``;
